import Subheading from './Subheading';

export default Subheading;
